module.exports = __webpack_public_path__ + "static/media/Trouser Image 1920-1080.a1707698.png";